<template>
  <v-app>
    <v-content>
      <my-app-bar />
      <message />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Message from './components/Message.vue'
import MyAppBar from './components/MyAppBar.vue'

export default {
  name: 'App',
  components: {
    Message,
    MyAppBar
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
